import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {InvSearchParamType} from "./interface";
import {invListMapInit, invSearchParamInit} from "./state";
import {useReadInv} from "./hooks/useReadInv";
import Filter from "./features/Filter";
import List from "./features/List";

export default function InvList() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<InvSearchParamType>(invSearchParamInit)

    const {data: inv} = useReadInv({param: searchParam});

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return <>
        <Filter searchParam={searchParam} setSearchParam={setSearchParam}/>

        <List inv={inv ?? invListMapInit} searchParam={searchParam}/>
    </>
}